export default "__VITE_ASSET__By3zOs2v__"